/* eslint-disable no-console */

import { register } from "register-service-worker";

const startWorker = callback => {
  const RegisteredEvent = new CustomEvent("swRegistered", { detail: null });
  const UpdatedEvent = new CustomEvent("swUpdated", { detail: null });
  const { NODE_ENV, VUE_APP_MODE } = process.env;
  if (NODE_ENV === "production" && VUE_APP_MODE === "Offline") {
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        if (callback) callback("ready");
        console.log("[Service Worker] ready");
        document.dispatchEvent(RegisteredEvent);
      },
      registered() {
        console.log("[Service Worker] registered");
      },
      cached() {
        console.log("[Service Worker] cached");
      },
      updatefound() {
        console.log("[Service Worker] updatefound");
      },
      updated() {
        console.log("[Service Worker] updated");
        document.dispatchEvent(UpdatedEvent);
      },
      offline() {
        console.log("[Service Worker] offline");
      },
      error(error) {
        console.error(
          "[Service Worker] Error during service worker registration:",
          error
        );
      }
    });
  }
};

export default startWorker;
